import React from 'react'
import { Link, NavLink } from 'react-router-dom'
import HeaderActions from './HeaderActions'

const MenuList = ({closeMenu}) => {
    return (
        <>
            <div className='text-center d-sm-none'>
                <div className='d-inline-flex align-items-center mt-4 mb-4'>
                    {/* <div className='me-3'>
                        <button className='btn common-btn btn-blue-bg' type='button'>Login</button>
                    </div>
                    <div>
                        <button className='btn common-btn' type='button'>Sign Up</button>
                    </div> */}
                    <HeaderActions/>
                </div>
            </div>
            {/* <ul className='d-flex align-items-center'>
                <li>
                    <NavLink to="/"

                        onClick={closeMenu}
                    >
                        Get Trip Ideas
                    </NavLink>
                </li>
                <li>
                    <Link to="/"

                        onClick={closeMenu}
                    >
                        Shop Gear
                    </Link>
                </li>
                <li>
                    <Link to="/"

                        onClick={closeMenu}
                    >
                        About
                    </Link>
                </li>
                <li>
                    <Link to="/"

                        onClick={closeMenu}
                    >
                        Contact
                    </Link>
                </li>
            </ul> */}
        </>
    )
}

export default MenuList